<template>
  <div class="categoryList" v-if="'punchoutIndex' === routeName">
    <div class="menu_home" @mouseleave="groupIndex = -1">
      <div class="menu_content">
        <div class="menutitle">
          <i class="el-icon-s-operation" style="margin-right: 5px"></i>产品分类
        </div>
        <!-- 左侧列表 -->
        <div class="menu_left flex-shrink">
          <div
            v-for="(items, idx) in categoryList"
            :key="idx"
            class="menu_left_item"
            :class="{ choosedGroup: idx === groupIndex }"
            @mouseover="
              groupIndex = idx
              groupItemIndex = 0
            "
          >
            <div
              class="menu_one ellipsis cursor-pointer"
              v-for="(item, index) in items"
              :key="index"
              @click.stop="openGoodList(item.categoryId)"
            >
              {{ item.categoryName }}
            </div>
          </div>
        </div>
        <!-- 右侧hover详情 -->
        <div class="menu_right flex-grow" v-show="groupIndex > -1">
          <!-- 一级类目组 -->
          <div class="menu_one_row flex-shrink">
            <div
              class="menu_one_title cursor-pointer"
              :class="{ menu_one_title_choosed: groupItemIndex === index }"
              v-for="(item, index) in groupIndex > -1
                ? categoryList[groupIndex]
                : []"
              :key="item.categoryId"
              @click.stop="openGoodList(item.categoryId)"
              @mouseover="groupItemIndex = index"
            >
              {{ item.categoryName }}
            </div>
          </div>
          <!-- 显示对应二级三级 -->
          <div class="menu_one_content flex-grow" v-show="groupItemIndex > -1">
            <div
              v-for="(twoItem, twoIndex) in groupIndex > -1 &&
              groupItemIndex > -1
                ? categoryList[groupIndex][groupItemIndex].children || []
                : []"
              :key="twoItem.categoryId"
            >
              <div
                class="two_menu_name cursor-pointer"
                @click.stop="openGoodList(twoItem.categoryId)"
              >
                {{ twoItem.categoryName }}
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="three_menu">
                <span
                  class="three_menu_name cursor-pointer"
                  @click.stop="openGoodList(threeItem.categoryId)"
                  v-for="threeItem in categoryList[groupIndex][groupItemIndex]
                    .children[twoIndex].children || []"
                  :key="threeItem.categoryId"
                  >{{ threeItem.categoryName }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'categoryList',
  data () {
    return {
      categoryList: [], // 产品类目
      groupIndex: -1, // 悬停组别的索引
      groupItemIndex: -1, // 悬停组别中类目的索引
      routeName: this.$route.name
    }
  },
  computed: {},
  created () {
    this.getCategoryList()
  },
  mounted () {
  },
  watch: {
    $route (route) {
      this.routeName = route.name
    }
  },
  methods: {
    // 获取分类列表
    getCategoryList () {
      this.$http
        .post(`/front/punchout/commodity/categoryList`)
        .then(({ data: res }) => {
          let categoryList = []
          let foregroundCategoryList = [].concat(
            res.data.foregroundCategoryList
          )
          if (
            res.data.foregroundCategoryList &&
            res.data.foregroundCategoryList.length
          ) {
            for (
              let i = 0;
              i < res.data.foregroundCategoryList.length;
              i += 2
            ) {
              categoryList.push(foregroundCategoryList.slice(i, i + 2))
            }
          }
          this.categoryList = categoryList
          // let list = []
          // for (let i = 0; i < 13; i++) {
          //   list = list.concat(res.data.foregroundCategoryList)
          // }
          this.$store.commit(
            'categoryListUpdate',
            res.data.foregroundCategoryList
          )
          this.bus.$emit('categoryList-event', res.data.foregroundCategoryList)
        })
        .catch(() => {})
    },
    // 打开搜索结果页
    openGoodList (id) {
      this.$router.push({
        name: 'punchoutGoodsList',
        query: {
          searchStr: '',
          categoryId: id,
          listType: '3' // 1. 检索列表 * 2.品牌列表 * 3.类目列表
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.categoryList {
  position: relative;
  .menu_home {
    position: absolute;
    width: 100%;
    top: 0;
    margin: 0 auto;
    .menu_content {
      width: 1190px;
      display: flex;
      margin: 0 auto;
      position: relative;
      .menutitle {
        height: 36px;
        width: 235px;
        background: #1d65a8;
        line-height: 36px;
        font-size: 16px;
        font-weight: 700;
        color: white;
        padding-left: 16px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }
      .menu_left {
        width: 235px;
        height: 406px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.07);
        background-color: white;
        z-index: 11;
        color: black;
        overflow-y: auto;
        margin-top: 36px;
        .menu_left_item {
          line-height: 37px;
          padding: 0 20px;
          .menu_one {
            color: #666;
            font-size: 14px;
            padding-right: 10px;
            display: inline-block;
            vertical-align: top;
            max-width: 50%;
            &:hover {
              color: #2e88ff;
            }
          }
        }
        .choosedGroup {
          background: rgba($color: #2e88ff, $alpha: 0.1);
        }
      }
      .menu_right {
        background-color: #fff;
        z-index: 11;
        display: flex;
        flex-direction: column;
        height: 443px;
        .menu_one_row {
          width: 100%;
          height: 45px;
          line-height: 45px;
          background: #fafafa;
          .menu_one_title {
            display: inline-block;
            color: #333;
            font-size: 16px;
            text-align: center;
            line-height: 45px;
            padding: 0px 20px;
            width: max-content;
          }
          .menu_one_title_choosed {
            background: #fff;
            color: #1d65a8;
          }
        }
        .menu_one_content {
          overflow-y: auto;
          padding: 0 30px;
          .two_menu_name {
            margin-top: 10px;
            line-height: 30px;
            font-size: 14px;
            font-weight: 500;
            color: #333;
          }
          .three_menu {
            font-size: 12px;
            font-weight: 400;
            color: #666;
            line-height: 25px;
            .three_menu_name {
              margin-right: 16px;
            }
          }
        }
      }
    }
  }
  div::-webkit-scrollbar {
    width: 8px;
    height: 10px;
    /**/
  }
  .menu-left::-webkit-scrollbar {
    display: none; /*隐藏滚动条*/
  }
  div::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
  }
  div::-webkit-scrollbar-thumb {
    background: #1d65a8;
    border-radius: 10px;
  }
  div::-webkit-scrollbar-thumb:hover {
    background: rgb(139, 176, 231);
  }
  div::-webkit-scrollbar-corner {
    background: #1d65a8;
  }
}
</style>
